<script>
  import { ClusterList } from "creditdesign-svelte-components";

  export let categoryList = [];
  export let selectedCategoryOne;
  export let selectedCategoryTwo;
</script>

<style>
  .category-list-item {
    padding: 3px 5px 3px 0;
    font-size: var(--font-size-small-1);
    font-weight: 400;
  }

  .category-list-item:not(:last-child) {
    border-right: 1px solid var(--white-3);
  }

  .selected {
    font-weight: 800;
  }
</style>

<ClusterList className="category-list" clusterSpace="var(--s-3)">
  {#each categoryList as category}
    {#if category.length}
      <li
        class="category-list-item"
        class:selected="{category === selectedCategoryOne || category === selectedCategoryTwo}"
      >
        {category}
      </li>
    {/if}
  {/each}
</ClusterList>
